module.exports = __webpack_public_path__ + "img/CLAUDIA_FERNANDES.d3ee6595.jpeg";